export default {
  getAdditionalFieldsTypes(state) {
    return state.additionalFieldsTypes
  },
}